import {
    BasicStyleRegistry,
    ComponentStyleDefinition,
    ComponentStylesDefinitions,
    StyleConfigurationUpdatedHook,
    StyleRegistry
} from "@zoovu/runner-browser-api";
import {loadFonts} from "./fonts/load-font-face";

export class StyleRegistryFactory {
    public static createStyleRegistry(
        defaultStyleDefinitions?: ComponentStylesDefinitions,
        rootContainerStyle?: ComponentStyleDefinition
    ): StyleRegistry {

        const configurationUpdatedHook: StyleConfigurationUpdatedHook =
            (configuration: any) => {
                if (configuration && configuration.fonts && configuration.fonts.fontType) {
                    loadFonts(configuration.fonts.fontType, configuration.globalThemeConfiguration);
                }
                return undefined;
            };

        return new BasicStyleRegistry(defaultStyleDefinitions, rootContainerStyle, configurationUpdatedHook);
    }
}
